// A small horizontal axis with tick marks at the endpoints and the
// numeric labels right under them. Pairs with RatingGaussian so the
// chart's domain is legible.

export type RatingAxisProps = {
  xMin: number
  xMax: number
  // Pixel width used for the viewBox. The SVG is fluid (width=100%) but
  // capped at this value via maxWidth so it lines up with the bell above.
  width?: number
  // Color for the line, ticks, and label text.
  color?: string
}

export const RatingAxis = ({
  xMin,
  xMax,
  width = 220,
  color = 'var(--ink-3)',
}: RatingAxisProps) => {
  const tickH = 4
  const lineY = 4
  return (
    <svg
      width="100%"
      height={20}
      viewBox={`0 0 ${width} 20`}
      preserveAspectRatio="none"
      aria-hidden
      style={{ display: 'block', maxWidth: width }}
    >
      <line x1={0} x2={width} y1={lineY} y2={lineY} stroke={color} strokeWidth={0.75} />
      <line x1={0.5} x2={0.5} y1={0} y2={lineY + tickH} stroke={color} strokeWidth={0.75} />
      <line
        x1={width - 0.5}
        x2={width - 0.5}
        y1={0}
        y2={lineY + tickH}
        stroke={color}
        strokeWidth={0.75}
      />
      <text
        x={0}
        y={18}
        fontSize={10}
        fontFamily="var(--font-mono)"
        fill={color}
        textAnchor="start"
      >
        {xMin}
      </text>
      <text
        x={width}
        y={18}
        fontSize={10}
        fontFamily="var(--font-mono)"
        fill={color}
        textAnchor="end"
      >
        {xMax}
      </text>
    </svg>
  )
}
